import { render, staticRenderFns } from "./FeesForWeightAndNoiseRegisterDialog.vue?vue&type=template&id=637f9979&"
import script from "./FeesForWeightAndNoiseRegisterDialog.vue?vue&type=script&lang=js&"
export * from "./FeesForWeightAndNoiseRegisterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637f9979')) {
      api.createRecord('637f9979', component.options)
    } else {
      api.reload('637f9979', component.options)
    }
    module.hot.accept("./FeesForWeightAndNoiseRegisterDialog.vue?vue&type=template&id=637f9979&", function () {
      api.rerender('637f9979', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/calculation/feesForWeightAndNoise/FeesForWeightAndNoiseRegisterDialog.vue"
export default component.exports